import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AboutWeCapture = () => {
  const navigate = useNavigate();

  const handleViewPortfolio = () => {
    navigate('/portfolio');
  };

  return (
    <section className="py-4 md:py-20 px-4 max-w-7xl mx-auto flex flex-col items-center gap-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-16 items-center">
        {/* Left Content */}
        <div className="space-y-8">
          <div>
            <h1 className="text-2xl lg:text-4xl font-bold text-gray-900 mb-8">
              About We capture
            </h1>
            
            <div className="">
              <p>
                As We Tekup grew, so did our vision.
              </p>
              <p>
                What started as a focus on building evolved into something more: the need to capture, tell, and elevate the stories behind the work.
              </p>
              <p>
                On April 25, 2025, we brought that vision to life with the launch of WE Capture Studio our dedicated space for photography and videography.
              </p>
            </div>
          </div>
              <div className="flex justify-start">
            <button
              onClick={handleViewPortfolio}
              className="inline-flex items-center gap-3 bg-primary-blue text-white px-3 md:px-4 py-1 md:py-2 rounded-full font-medium text-lg hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 group"
            >
              <span className='text-base md:text-lg'>View our portfolio</span>
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                <FaArrowRight className="text-black text-sm" />
              </div>
            </button>
          </div>
          
        </div>

        {/* Right Content - Logos */}
        <div className="flex flex-col items-center justify-center relative">
          {/* We Tekup Logo */}
          <div className="flex flex-col items-start text-center w-[80%]">
            <div className='flex flex-col items-center'>
                <div className="mb-2">
                    <img 
                        src="/wetekuplogo.svg" 
                        alt="We Tekup Logo" 
                        className="md:w-12 md:h-12 h-8 w-8 object-contain"
                    />
                </div>
                    <h3 className="text-2xl font-bold text-gray-900">
                    <span className="font-light">We</span>
                    <span className="font-bold">Tekup</span>
                    </h3>
            </div>
            
          </div>

          {/* Arrow */}
          <div className="flex items-center justify-start  px-8  w-[80%]">
            <img 
              src="/arrow.svg" 
              alt="Arrow" 
              className="w-24 h-24 object-contain"
            />
          </div>

          {/* We Capture Logo */}
          <div className="flex flex-col items-center text-center -mt-6 max-md:ml-16 md:mr-20">
            <div className="mb-2">
              <img 
                src="/wecapturelogo.svg" 
                alt="We Capture Logo" 
                className="w-[60px] h-[60px] object-contain"
              />
            </div>
            <h3 className="text-2xl font-bold text-gray-900">
              <span className="font-light">We</span>
              <span className="font-bold">Capture</span>
            </h3>
          </div>

         
        </div>
      </div>

    </section>
  );
};

export default AboutWeCapture;